module.exports = __webpack_public_path__ + "static/img/header-logo.5b136ab5.svg";